<template>
  <div class="home">
    <Contenido v-if="datos || buscando && !error" :endEtiquetas="endEtiquetas" :cuentasEtiquetadas="cuentasEtiquetadas" :userData="datos" :error="error" v-on:analizar="analizar" />
    <ErrorPage v-else-if="error" :error="error" :nickName="nickName" v-on:resetear="reset" />
    <Buscar v-else v-on:analizar="analizar"/>
  </div>
</template>

<script>
import ErrorPage from '@/components/error-page.vue'
import Contenido from "@/components/contenido";
import Buscar from "@/components/buscar";
export default {
  name: 'Home',

  components: {
    ErrorPage,
    Contenido,
    Buscar
  },

  data: () => ({
    maxPost: 50,
    buscando: null,
    datos: null,
    error: null,
    nickName: null,
    id_usuario: null,
    datosProvisionales: null,
    end_cursor: null,
    cuentasEtiquetadas: [],
    endEtiquetas: null
  }),

  watch:{
    datos() {
      this.listaEtiquetadas()
    }
  },

  mounted() {
    this.parametroNickBuscar()
  },

  methods: {
    sanitizar(name) {
      if (!name || typeof name !== 'string') {
        console.error(`No es un texto válido no es válido`)
        return null;
      }
      const patt = new RegExp(/^(?!.*\.\.)(?!.*\.$)[^\W][\w.]{0,29}$/igm); // [^\\u00F1] => ñ
      const str = name.replace(/@|\s/g, ""); // Elimina @ y espacios en blanco
      const res = patt.test(str);
      this.nickName = str
      return res ? str : null;
    },

    async analizar(nick) {
      const e = this.sanitizar(nick);
      if (!e) {
        console.error('No se puede analizar este nickname');
        this.error = true
        return;
      }
      this.reset()
      this.buscando = true
      const url = `https://www.instagram.com/${e}/?__a=1`
      await this.$http.get(url)
        .then((response) => {
          const data = response.data;
          if (data.graphql && data.graphql.user) {
            if(data.graphql.user.is_private) {
              this.buscando = false
              this.datos = data.graphql.user;
              return;
            }
            this.datosProvisionales = data.graphql.user;
            this.end_cursor = this.datosProvisionales.edge_owner_to_timeline_media.page_info.end_cursor
            const has_next_page = this.datosProvisionales.edge_owner_to_timeline_media.page_info.has_next_page
            if (!has_next_page) {
              this.buscando = false;
              this.datos = this.datosProvisionales;
              return;
            }
            this.scrapNext();
          } else {
            this.buscando = false;
            this.error = data;
          }
        }).catch((error) => {
          this.buscando = false;
          this.error = error;
          console.error(error);
        });
    },

    async scrapNext() {
      if (!this.datosProvisionales) {
        this.buscando = false;
        return;
      }
      const totalPost = this.datosProvisionales.edge_owner_to_timeline_media.edges.length
      // Termina las consultas
      if (totalPost >= this.maxPost) {
        this.buscando = false;
        this.datos = this.datosProvisionales
        return
      }
      // Continua las consultas
      const query_hash = '472f257a40c653c64c666ce877d59d2b'
      const id_usuario = this.datosProvisionales.id
      const url = `https://www.instagram.com/graphql/query/?query_hash=${query_hash}&variables={"id":"${id_usuario}","first":12,"after":"${this.end_cursor}"}`
      await this.$http.get(url)
        .then((response) => {
          const data = response.data;
          if (data.data && data.data.user) {
            this.datosProvisionales.edge_owner_to_timeline_media.edges = this.datosProvisionales.edge_owner_to_timeline_media.edges.concat(data.data.user.edge_owner_to_timeline_media.edges)
            this.end_cursor = data.data.user.edge_owner_to_timeline_media.page_info.end_cursor
            const has_next_page = data.data.user.edge_owner_to_timeline_media.page_info.has_next_page
            // Termina las consultas
            if (!has_next_page) {
              this.buscando = false;
              this.datos = this.datosProvisionales;
              return;
            }
            this.scrapNext();
          } else {
            this.buscando = false;
            this.error = data;
          }
        }).catch((error) => {
          this.buscando = false;
          this.error = error;
          console.error(error);
        });
    },

    async listaEtiquetadas() {
      if (!this.datos) {
        return;
      }
      const medias = this.datos.edge_owner_to_timeline_media.edges
      for (const m of medias) {
        const url = `https://www.instagram.com/p/${m.node.shortcode}/?__a=1`
        const etiquetas = await this.etiquetadasNext(url)
        if (etiquetas) {
          this.cuentasEtiquetadas = this.cuentasEtiquetadas.concat(etiquetas)
          continue
        }
        console.error('Sin etiquetas')
      }
      this.endEtiquetas = true;
    },

    async etiquetadasNext(url) {
      let result = null
      await this.$http.get(url)
        .then((response) => {
          const data = response.data;
          if (data.graphql && data.graphql.shortcode_media.edge_media_to_tagged_user) {
            result = data.graphql.shortcode_media.edge_media_to_tagged_user.edges
          } else {
            console.error(data);
          }
        }).catch((error) => {
          console.error(error);
        });
      return result;
    },

    parametroNickBuscar() {
      const q = this.$route.query
      const keys = Object.keys(q)
      if (q && keys.includes('nick')) {
        const nick = decodeURI(q.nick)
        this.analizar(nick)
      }
      return
    },

    reset() {
      this.buscando = this.datos = this.error = this.nickName = this.id_usuario = this.id_usuario = this.end_cursor = this.endEtiquetas = null
      this.cuentasEtiquetadas = []
    }
  }
}
</script>
